module.exports = __webpack_public_path__ + "img/staticclingsm.5a78e7c1.webp";